// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wwcStatus":"wwc-status__wwcStatus--11Czs","subtitle2":"wwc-status__subtitle2--2tEcy","link":"wwc-status__link--2TUzv"};